(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mix-match-packs-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mix-match-packs-upsell')) {
    class MixMatchPacksUpsell extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.backdrop = this.querySelector('[data-mmpu-backdrop]');
        this.dialog = this.querySelector('[data-mmpu-dialog]');
        this.closeBtn = this.querySelector('[data-mmpu-close]');
        this.addButtons = Array.from(this.querySelectorAll('[data-mmpu-add]'));
        this.storageKey = this.dataset.storageKey || 'nwMixMatchUpsellShown';
        this.mixMatchType = (this.dataset.mixMatchProductType || 'Mix & Match').trim().toLowerCase();
        this.isOpen = false;
        this.pendingAdd = false;
        this.suppressAutoClose = false;

        this.shippingRoot = this.querySelector('[data-mmpu-shipping]');
        this.shippingLine1 = this.querySelector('[data-mmpu-shipping-line1]');
        this.shippingLine2 = this.querySelector('[data-mmpu-shipping-line2]');
        this.shippingFill = this.querySelector('[data-mmpu-shipping-fill]');
        this.shippingMascot = this.querySelector('[data-mmpu-shipping-mascot]');
        this.mascotProgressImg = this.querySelector('[data-mmpu-mascot-progress]');
        this.mascotUnlockedImg = this.querySelector('[data-mmpu-mascot-unlocked]');
        this.freeShippingThresholdCents = Number(this.dataset.freeShippingThresholdCents) || 3000;
        this.shippingLine1LockedTemplate = this.dataset.shippingLine1LockedTemplate || 'Just {amount} more to unlock free shipping';
        this.shippingLine2Locked = this.dataset.shippingLine2Locked || '';
        this.shippingLine1Unlocked = this.dataset.shippingLine1Unlocked || 'Free shipping unlocked!';
        this.shippingLine2Unlocked = this.dataset.shippingLine2Unlocked || '';

        this.closeBtn?.addEventListener('click', () => this.close());
        this.backdrop?.addEventListener('click', () => this.close());
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.isOpen) this.close();
        });

        this.addButtons.forEach((button) => {
          button.addEventListener('click', () => this.addPack(button));
        });

        document.addEventListener('cart:updated', (event) => {
          this.evaluate(event.detail && event.detail.cart);
        });

        // Vérifie l'état initial (le panier peut déjà être 100% Mix & Match
        // au chargement de la page, sans qu'aucun événement cart:updated ne
        // se déclenche pendant cette visite).
        this.evaluate();
      }

      async evaluate(knownCart) {
        let cart = knownCart;
        try {
          if (!cart) {
            const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            cart = await response.json();
          }
        } catch (error) {
          return;
        }
        if (!cart) return;

        this.updateShippingProgress(cart);

        if (!cart.item_count) {
          // Panier vide : on relâche le verrou pour permettre une nouvelle
          // proposition si le client recompose un panier 100% Mix & Match
          // plus tard dans la même session.
          try { sessionStorage.removeItem(this.storageKey); } catch (error) {}
          if (this.isOpen) this.close();
          return;
        }

        const onlyMixMatch = cart.items.every((item) => {
          const type = (item.product_type || '').trim().toLowerCase();
          return type === this.mixMatchType;
        });

        if (!onlyMixMatch) {
          // Si un pack vient d'être ajouté, on laisse le popup ouvert le
          // temps de montrer l'état final de la barre / mascotte, même si
          // le panier n'est plus 100% Mix & Match (le pack ne l'est pas).
          if (this.isOpen && !this.suppressAutoClose) this.close();
          return;
        }

        let alreadyShown = false;
        try { alreadyShown = sessionStorage.getItem(this.storageKey) === '1'; } catch (error) {}
        if (alreadyShown || this.isOpen || this.pendingAdd) return;

        this.open();
      }

      formatMoney(cents) {
        const amount = Math.max(cents, 0) / 100;
        return amount.toFixed(2).replace('.', ',') + ' €';
      }

      updateShippingProgress(cart) {
        if (!this.shippingFill || !this.shippingMascot) return;

        const total = cart.total_price || 0;
        const threshold = this.freeShippingThresholdCents;
        const progress = Math.min((total / threshold) * 100, 100);
        const mascotPosition = Math.min(Math.max(progress, 7), 93);
        const unlocked = total >= threshold;

        this.shippingFill.style.width = progress + '%';
        this.shippingMascot.style.left = mascotPosition + '%';
        this.shippingRoot?.classList.toggle('is-shipping-unlocked', unlocked);
        this.mascotProgressImg?.classList.toggle('is-active', !unlocked);
        this.mascotUnlockedImg?.classList.toggle('is-active', unlocked);

        if (this.shippingLine1 && this.shippingLine2) {
          if (unlocked) {
            this.shippingLine1.textContent = this.shippingLine1Unlocked;
            this.shippingLine2.textContent = this.shippingLine2Unlocked;
          } else {
            this.shippingLine1.textContent = this.shippingLine1LockedTemplate.replace('{amount}', this.formatMoney(threshold - total));
            this.shippingLine2.textContent = this.shippingLine2Locked;
          }
        }
      }

      open() {
        this.isOpen = true;
        this.hidden = false;
        // Force le reflow pour que la transition d'ouverture joue.
        void this.offsetWidth;
        this.classList.add('is-open');
        this.dialog?.setAttribute('aria-hidden', 'false');
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (error) {}
        this.closeBtn?.focus();
      }

      close() {
        this.isOpen = false;
        this.classList.remove('is-open');
        this.dialog?.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          if (!this.isOpen) this.hidden = true;
        }, 260);
      }

      async addPack(button) {
        const variantId = Number(button.dataset.variantId);
        if (!variantId || this.pendingAdd) return;

        this.pendingAdd = true;
        const label = button.querySelector('[data-mmpu-btn-label]');
        const previousLabel = label ? label.textContent : '';
        const errorEl = button.closest('[data-mmpu-pack]')?.querySelector('[data-mmpu-pack-error]');

        this.addButtons.forEach((btn) => { btn.disabled = true; });
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = this.dataset.addingLabel;
        if (errorEl) errorEl.hidden = true;

        try {
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections }
          }));

          const addRoute = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
          const response = await fetch(addRoute, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1, properties: { _mix_match_pack_upsell: 'true' } }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || this.dataset.errorLabel);

          if (label) label.textContent = this.dataset.addedLabel;

          // Empêche l'écouteur cart:updated de refermer le popup pendant
          // qu'on montre l'état final de la barre / mascotte.
          this.suppressAutoClose = true;

          const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          this.updateShippingProgress(cart);

          if (window.theme?.pubsub) {
            cart.sections = state.sections;
            window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'mix-match-packs-upsell',
              cart
            });
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'mix_match_packs_upsell_add',
            mix_match_packs_upsell: { pack_handle: button.dataset.packHandle, variant_id: variantId }
          });

          setTimeout(() => {
            this.suppressAutoClose = false;
            this.close();
          }, 1500);
        } catch (error) {
          if (errorEl) {
            errorEl.textContent = error.message || this.dataset.errorLabel;
            errorEl.hidden = false;
          }
          if (label) label.textContent = previousLabel;
          this.addButtons.forEach((btn) => { btn.disabled = !btn.dataset.variantId; });
        } finally {
          this.pendingAdd = false;
          button.removeAttribute('aria-busy');
          this.addButtons.forEach((btn) => {
            if (btn.dataset.variantId) btn.disabled = false;
          });
        }
      }
    }

    customElements.define('mix-match-packs-upsell', MixMatchPacksUpsell);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix-match"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nawhals-mix-match')) {
    class NawhalsMixMatch extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.mode = 'spicy';
        this.mainButton = this.querySelector('[data-add-combo]');
        this.stickyButton = this.querySelector('[data-sticky-add]');
        this.stickyBar = this.querySelector('[data-sticky-bar]');
        this.error = this.querySelector('[data-error]');
        this.hasSeenMainButton = false;
        this.mainButtonVisible = false;
        this.sectionVisible = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('[data-choice]').forEach((button) => {
          button.addEventListener('click', () => this.selectMode(button.dataset.choice));
        });
        this.mainButton?.addEventListener('click', () => this.addCombo(this.mainButton));
        this.stickyButton?.addEventListener('click', () => this.addCombo(this.stickyButton));
        this.observeVisibility();
        this.observeReveal();
        this.setupTilt();
        this.trackView();
      }

      setupTilt() {
        if (this.reducedMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const stage = this.querySelector('.mix-match__visual');
        if (!stage) return;

        const init = () => {
          if (!window.VanillaTilt) return;
          window.VanillaTilt.init(stage, {
            max: 8,
            speed: 400,
            scale: 1.02,
            perspective: 1200,
            glare: false,
            gyroscope: false
          });
        };

        if (window.VanillaTilt) {
          init();
          return;
        }

        let loader = document.querySelector('script[data-vanilla-tilt]');
        if (!loader) {
          loader = document.createElement('script');
          loader.src = 'https://cdn.jsdelivr.net/npm/vanilla-tilt@1.8.1/dist/vanilla-tilt.min.js';
          loader.defer = true;
          loader.dataset.vanillaTilt = 'true';
          document.head.appendChild(loader);
        }
        loader.addEventListener('load', init, { once: true });
      }

      observeReveal() {
        if (this.reducedMotion || !('IntersectionObserver' in window)) return;
        this.classList.add('mix-match--pre-reveal');
        this.revealObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          this.classList.remove('mix-match--pre-reveal');
          this.classList.add('mix-match--revealed');
          this.revealObserver.disconnect();
        }, { threshold: 0.2 });
        this.revealObserver.observe(this);
      }

      selectMode(mode) {
        if (mode === this.mode) return;
        const choice = this.querySelector(`[data-choice="${mode}"]`);
        if (!choice || choice.disabled) return;

        const forward = mode === 'mild';
        this.mode = mode;
        this.dataset.mode = mode;
        this.dataset.direction = forward ? 'forward' : 'back';

        if (!this.reducedMotion) {
          this.style.setProperty('--mm-flood-color', forward ? 'var(--mm-mild)' : 'var(--mm-spicy)');
          this.classList.add('mm-is-flooding');
          window.setTimeout(() => this.classList.remove('mm-is-flooding'), 520);
        }

        this.querySelectorAll('[data-choice]').forEach((button) => {
          const active = button.dataset.choice === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active.toString());
        });
        this.querySelectorAll('[data-primary]').forEach((product) => {
          product.setAttribute('aria-hidden', (product.dataset.primary !== mode).toString());
        });
        this.querySelectorAll('[data-combo-name]').forEach((node) => {
          this.swapText(node, this.dataset[`${mode}Name`], forward);
        });
        this.swapText(this.querySelector('[data-combo-description]'), this.dataset[`${mode}Description`], forward);
        this.swapText(this.querySelector('[data-price-value]'), this.dataset[`${mode}Value`], forward);
        this.swapText(this.querySelector('[data-price-total]'), this.dataset[`${mode}Total`], forward);
        this.querySelector('[data-add-label]').textContent = this.dataset[`${mode}Button`];
        this.querySelector('[data-sticky-name]').textContent = this.dataset[`${mode}ShortName`];
        this.querySelector('[data-sticky-price]').textContent = this.dataset[`${mode}Total`];
        const available = this.dataset[`${mode}Available`] === 'true';
        this.mainButton.disabled = !available;
        this.stickyButton.disabled = !available;

        this.track('mix_match_select', { choice: mode });
      }

      swapText(el, value, forward) {
        if (!el) return;
        if (this.reducedMotion) {
          el.textContent = value;
          return;
        }
        const activeClass = forward ? 'mm-swap-fwd' : 'mm-swap-back';
        el.classList.remove('mm-swap-fwd', 'mm-swap-back');
        void el.offsetWidth;
        el.classList.add(activeClass);
        window.setTimeout(() => {
          el.textContent = value;
        }, 150);
        window.setTimeout(() => {
          el.classList.remove(activeClass);
        }, 300);
      }

      async addCombo(sourceButton) {
        if (this.dataset.offerEnabled !== 'true') return;
        const primaryVariantId = Number(this.dataset[`${this.mode}VariantId`]);
        const giftVariantId = Number(this.dataset.giftVariantId);
        if (!primaryVariantId || !giftVariantId || sourceButton.disabled) return;

        const bundleId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = [
          { id: primaryVariantId, quantity: 1, properties: { _mix_match: this.mode, _mix_match_id: bundleId } },
          { id: giftVariantId, quantity: 1, properties: { _mix_match: this.mode, _mix_match_id: bundleId, _mix_match_gift: 'true' } }
        ];
        const label = this.mainButton.querySelector('[data-add-label]');
        const previousLabel = label.textContent;

        this.setBusy(true);
        label.textContent = this.dataset.addingLabel;
        this.error.hidden = true;
        this.track('mix_match_add_to_cart', {
          choice: this.mode,
          primary_variant_id: primaryVariantId,
          gift_variant_id: giftVariantId,
          value: this.dataset[`${this.mode}Total`]
        });

        try {
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
            bubbles: true,
            detail: { sections }
          }));
          const route = window.theme?.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(route, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(state.description || this.dataset.errorLabel);

          if (window.theme?.pubsub && sections.length) {
            const cartResponse = await fetch(window.theme.routes.cart_url, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            cart.sections = state.sections;
            window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'nawhals-mix-match',
              cart
            });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
            document.querySelector('cart-drawer')?.show(sourceButton);
          } else {
            window.location.assign(window.theme?.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
          }
          this.track('mix_match_add_success', { choice: this.mode });
        } catch (error) {
          this.error.textContent = error.message || this.dataset.errorLabel;
          this.error.hidden = false;
          this.track('mix_match_add_error', { choice: this.mode, message: this.error.textContent });
        } finally {
          label.textContent = previousLabel;
          this.setBusy(false);
        }
      }

      setBusy(busy) {
        this.mainButton.setAttribute('aria-busy', busy.toString());
        this.mainButton.disabled = busy;
        this.stickyButton.disabled = busy;
      }

      observeVisibility() {
        if (!this.mainButton || !this.stickyBar || !('IntersectionObserver' in window)) return;
        this.buttonObserver = new IntersectionObserver(([entry]) => {
          this.mainButtonVisible = entry.isIntersecting;
          if (entry.isIntersecting) this.hasSeenMainButton = true;
          this.updateSticky();
        }, { threshold: 0.15 });
        this.sectionObserver = new IntersectionObserver(([entry]) => {
          this.sectionVisible = entry.isIntersecting;
          this.updateSticky();
        }, { threshold: 0.01 });
        this.buttonObserver.observe(this.mainButton);
        this.sectionObserver.observe(this.querySelector('.mix-match__section'));
      }

      updateSticky() {
        const show = window.matchMedia('(max-width: 767px)').matches && this.sectionVisible && this.hasSeenMainButton && !this.mainButtonVisible;
        this.stickyBar.hidden = !show;
        this.stickyBar.setAttribute('aria-hidden', (!show).toString());
      }

      trackView() {
        if (!('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          this.track('mix_match_view', { headline_variant: this.dataset.headlineVariant });
          observer.disconnect();
        }, { threshold: 0.35 });
        observer.observe(this);
      }

      track(event, detail = {}) {
        if (this.dataset.offerEnabled !== 'true') return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, mix_match: { section_id: this.dataset.sectionId, ...detail } });
        this.dispatchEvent(new CustomEvent(event, { bubbles: true, detail }));
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.sectionObserver?.disconnect();
        this.revealObserver?.disconnect();
        this.querySelector('.mix-match__visual')?.vanillaTilt?.destroy();
      }
    }

    customElements.define('nawhals-mix-match', NawhalsMixMatch);
  }

  } catch(e) { console.error(e); }
})();
})();
